import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentRegisterDto extends EpimsBaseEntityDto {
    
    EventTypeId: string;
    ReportingPersonId: string;
    ReportingPersonName: string;  
    ReportedAs: string; 
    LocationId: string;  
    LocationName: string;  
    ReportAt: Date;  
    ReportTime: string;
    IncidentTrackingNo: string;
 
    IncidentCode: string;
    RiskAreaId : string;
    RiskAreaName : string;
    Title : string;
    Description : string;
    OwnerId : string;
    OwnerName : string;
    Status : string;
    ReAssignId : string;
    ReAssignName : string;
    ReAssignAt : string;

    ActionEmbarked: string; 
    ResolutionsReached: string;
    

}